import { useState, useEffect } from 'react'
import LayoutAccount from '@components/common/LayoutAccount'
import withDataLayer, { PAGE_TYPES } from '@components/withDataLayer'
import { config } from '@components/utils/myAccount'
import { useRouter } from 'next/router'
import { Image } from '@components/common'
import Link from 'next/link'
import { EVENTS_MAP } from '@components/services/analytics/constants'
import useAnalytics from '@components/services/analytics/useAnalytics'
import { useUI } from '@components/ui/context'

import NextHead from 'next/head'
import React from 'react'
import MyDetails from '@components/account/Profile/MyDetails'
import { EmptyGuid, NEXT_REFERRAL_PROGRAM } from '@components/utils/constants'
import axios from '@services/axiosInterceptorInstance'
import { recordGA4Event } from '@components/services/analytics/ga4'
import { IPagePropsProvider } from '@framework/contracts/page-props/IPagePropsProvider'
import { PagePropType, getPagePropType } from '@framework/page-props'
import useEventAnalytics from '@components/services/analytics/useEventAnalytics'
import { AnalyticsEventType } from '@components/services/analytics'
import { getUserNumber } from '@components/account/loginHelper'
import { IMAGE_ASSET_BASE_URL } from '@framework/utils/constants'
function MyAccount({ defaultView, deviceInfo }: any) {
  let hostName = ''
  if (typeof window !== 'undefined') {
    hostName = window?.location?.hostname ?? ''
  }
  const { isGuestUser, user, deleteUser, closeSidebar, openCart, cartItems } = useUI()
  const [isShow, setShow] = useState(true)
  const [view, setView] = useState(defaultView)
  const [isReferVisible, setReferVisible] = useState(false)
  const [active, setActive] = useState(false)

  const router = useRouter()
  const { recordAnalytics } = useEventAnalytics()
  const { CustomerProfileViewed } = EVENTS_MAP.EVENT_TYPES
  const { Customer } = EVENTS_MAP.ENTITY_TYPES
  const { isMobile, isOnlyMobile, isIPadorTablet } = deviceInfo
  const isUserLoggedIn =
    !isGuestUser && user?.userId && user?.userId !== EmptyGuid

  useEffect(() => {
    getReferVisibiliy()
    recordAnalytics(AnalyticsEventType.OTHER_PAGE, { type: 'other', data: { cartItems } })
  }, [])

  const getReferVisibiliy = async () => {
    try {
      const response: any = await axios.get(NEXT_REFERRAL_PROGRAM)
      if (
        response?.data?.result?.success &&
        response?.data?.result?.result?.referrerPromo &&
        response?.data?.result?.result?.refereePromo
      ) {
        setReferVisible(true)
      } else {
        setReferVisible(false)
      }
    } catch (error: any) {
      console.error(':: error ', error)
    }
  }

  const getReferAndEarnButton = (item: any, idx: any) => {
    if (isReferVisible) {
      return (
        <>
          <div
            key={`my-acc-${idx}`}
            onClick={() => item.onClick(user)}
            className={`ring-white relative ring-opacity-60 border-b border-slate-300 sm:border-0 cursor-pointer ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2  w-full  text-14  leading-5 text-left pl-4 ${item.text == 'My Profile'
                ? 'bg-white border-r-0  sm:border-b-0 sm:border-r-2 sm:border-black sm:font-bold sm:opacity-full'
                : 'text-primary font-medium opacity-60'
              }`}
          >
            <span className="pr-2 leading-none align-middle acc-mob-icon-i sm:absolute top-2/4 -translate-y-2/4">
              <i className={item.text.toLowerCase() + ' ' + 'sprite-icon'} />
            </span>

            {item.text == 'My Profile' ? (
              <>
                {(isMobile || isIPadorTablet) && (
                  <span
                    onClick={() =>
                      isOnlyMobile
                        ? router.replace(item.href)
                        : router?.push(item?.href)
                    }
                  >
                    <span
                      onClick={() => {
                        handleClick
                        setShow(false)
                      }}
                      className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary"
                    >
                      <span className="inline-block sm:hidden">
                        {item.mtext}
                      </span>
                      <span className="hidden sm:inline-block">
                        {item.text}
                      </span>
                    </span>
                  </span>
                )}
                {!(isMobile || isIPadorTablet) && (
                  <span
                    onClick={() =>
                      isOnlyMobile
                        ? router.replace(item.href)
                        : router?.push(item?.href)
                    }
                  >
                    <span className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary">
                      <span className="inline-block sm:hidden">
                        {item.mtext}
                      </span>
                      <span className="hidden sm:inline-block">
                        {item.text}
                      </span>
                    </span>
                  </span>
                )}
              </>
            ) : (
              <>
                <span
                  onClick={() =>
                    isOnlyMobile
                      ? router.replace(item.href)
                      : router.push(item.href)
                  }
                >
                  <span className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary">
                    <span className="inline-block sm:hidden">{item.mtext}</span>
                    <span className="hidden sm:inline-block">{item.text}</span>
                  </span>
                </span>
              </>
            )}
          </div>
        </>
      )
    } else {
      return null
    }
  }

  useEffect(() => {
    if (!isOnlyMobile) {
      const isCartShouldOpen = router.asPath?.includes('#cartopen')
      if (isCartShouldOpen) {
        openCart()
      } else {
        closeSidebar()
      }
    }
    if (router.query.view && view !== router.query.view) {
      setView(router.query.view)
    }
  }, [router.asPath])

  let loggedInEventData: any = {
    eventType: CustomerProfileViewed,
  }

  if (user && user.userId) {
    loggedInEventData = {
      ...loggedInEventData,
      entity: JSON.stringify({
        email: user.email,
        dateOfBirth: user.yearOfBirth,
        gender: user.gender,
        id: user.userId,
        name: user.firstName + user.lastName,
        postCode: user.postCode,
      }),
      entityId: user.userId,
      entityName: user.firstName + user.lastName,
      entityType: Customer,
    }
  }

  const handleClick = () => {
    setActive(!active)
  }

  useAnalytics(CustomerProfileViewed, loggedInEventData)
  const logoutGAEvent = () => {
    recordGA4Event(window, 'logout', {})
  }

  const css = { maxWidth: '100%', height: 'auto' }

  return (
    <>
      {hostName && <input className="inst" type="hidden" value={hostName} />}
      <NextHead>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <link
          rel="canonical"
          id="canonical"
          href={'https://www.damensch.com' + router.asPath}
        />
        <title>My Account</title>
        <meta name="title" content="My Account" />
        <meta name="description" content="My Account" />
        <meta name="keywords" content="My Account, DaMENSCH Account" />
        <meta property="og:image" content="" />
        <meta property="og:title" content="My Account" key="ogtitle" />
        <meta property="og:description" content="My Account" key="ogdesc" />
      </NextHead>
      <>
        <section className="relative pb-10 text-gray-900">
          <div className="w-full px-0 mx-auto accunt-main-container sm:px-0 lg:px-0">
            <div
              className={`px-6 py-4 mb-2 border-b mob-header sm:hidden ${isShow ? `` : 'mob-hidden'
                }`}
            >
              <h3 className="max-w-4xl mx-auto text-xl font-semibold text-black">
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    router.back()
                  }}
                >
                  <span className="mr-2 leading-none">
                    <i className="sprite-icon sprite-left-arrow" />
                  </span>
                </span>
                Profile
              </h3>
            </div>
            <div
              className={`grid w-full grid-cols-12 ${isShow ? 'px-4' : 'px-0'
                } sm:px-2 sm:pr-0 main-account-grid`}
            >
              <div
                className={`col-span-3 pl-0 sm:pl-6 border-r border-gray-200 tab-list-sm sm:pt-10 mob-tab-full ${isShow ? `` : 'mob-hidden'
                  }`}
              >
                {isUserLoggedIn ? (
                  <div className="w-full block px-4 py-3 mb-4 border-b border-gray-200 sm:hidden full-m-pro-header">
                    <h3 className="text-xl font-bold capitalize text-primary">
                      {user?.firstName != '' ? (
                        <>
                          {user?.firstName} {user?.lastName}
                        </>
                      ) : (
                        <>Hi</>
                      )}
                    </h3>
                    <p className="mt-2 text-sm text-brown-light">
                      {getUserNumber(user)} • {user?.email}
                    </p>
                  </div>
                ) : null}
                <div className="sticky left-0 z-10 flex flex-col top-36">
                  {config.map((item: any, idx: number) => {
                    if (item?.props === 'refer-earn') {
                      return getReferAndEarnButton(item, idx)
                    } else {
                      return (
                        <>
                          <div
                            key={`my-acc-${idx}`}
                            // href="#"
                            onClick={() => item.onClick(user)}
                            className={`ring-white relative ring-opacity-60 border-b border-slate-300 sm:border-0 cursor-pointer ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2  w-full  text-14  leading-5 text-left pl-4 ${item.text == 'My Profile'
                                ? 'bg-white border-r-0  sm:border-b-0 sm:border-r-2 sm:border-black sm:font-bold sm:opacity-full'
                                : 'text-primary font-medium opacity-60'
                              }`}
                          >
                            <span className="pr-2 leading-none align-middle acc-mob-icon-i sm:absolute top-2/4 -translate-y-2/4">
                              <i
                                className={
                                  item.text.toLowerCase() + ' ' + 'sprite-icon'
                                }
                              />
                            </span>

                            {item.text == 'My Profile' ? (
                              <>
                                {(isMobile || isIPadorTablet) && (
                                  <span
                                    onClick={() =>
                                      isOnlyMobile
                                        ? router.replace(item.href)
                                        : router?.push(item?.href)
                                    }
                                  >
                                    <span
                                      onClick={() => {
                                        handleClick
                                        setShow(false)
                                      }}
                                      className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary"
                                    >
                                      <span className="inline-block sm:hidden">
                                        {item.mtext}
                                      </span>
                                      <span className="hidden sm:inline-block">
                                        {item.text}
                                      </span>
                                    </span>
                                  </span>
                                )}
                                {!(isMobile || isIPadorTablet) && (
                                  <span
                                    onClick={() =>
                                      isOnlyMobile
                                        ? router.replace(item.href)
                                        : router?.push(item?.href)
                                    }
                                  >
                                    <span className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary">
                                      <span className="inline-block sm:hidden">
                                        {item.mtext}
                                      </span>
                                      <span className="hidden sm:inline-block">
                                        {item.text}
                                      </span>
                                    </span>
                                  </span>
                                )}
                              </>
                            ) : (
                              <>
                                <span
                                  onClick={() =>
                                    isOnlyMobile
                                      ? router.replace(item.href)
                                      : router.push(item.href)
                                  }
                                >
                                  <span className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary">
                                    <span className="inline-block sm:hidden">
                                      {item.mtext}
                                    </span>
                                    <span className="hidden sm:inline-block">
                                      {item.text}
                                    </span>
                                  </span>
                                </span>
                              </>
                            )}
                          </div>
                        </>
                      )
                    }
                  })}
                  {isUserLoggedIn ? (
                    <div
                      key={`my-acc-logout`}
                      // href="#"
                      onClick={() => (deleteUser(), logoutGAEvent())}
                      className="relative w-full pl-4 leading-5 text-left border-b cursor-pointer ring-white ring-opacity-60 border-slate-300 sm:border-0 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2 text-14 opacity-60"
                    >
                      <span className="pr-2 leading-none align-middle acc-mob-icon-i sm:absolute top-2/4 -translate-y-2/4">
                        <i className="sprite-icon sprite-logout"></i>
                      </span>
                      <Link
                        legacyBehavior
                        key="logout"
                        href=""
                        passHref
                        shallow={true}
                      >
                        <span
                          className="inline-block w-full h-full py-4 text-sm sm:pl-8 text-primary"
                          onClick={() => deleteUser()}
                        >
                          Logout
                        </span>
                      </Link>
                    </div>
                  ) : null}
                </div>
              </div>

              <div
                className={`relative col-span-9 border-l tabpanel-sm mob-tab-full ${isShow ? `mob-hidden` : ''
                  }`}
              >
                <div className={'orders bg-white sm:my-6 my-profile-div'}>
                  <MyDetails isShow={isShow} setShow={setShow} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className={`block sm:hidden px-8 ${isShow ? `` : 'mob-hidden'}`}>
          <h4 className="mb-2 text-xs font-normal text-brown-light">
            Made with love by
          </h4>
          <p>
            <Image
              priority={true}
              src={`${IMAGE_ASSET_BASE_URL}/icons/dapeople.svg`}
              blurDataURL={`${IMAGE_ASSET_BASE_URL}/icons/dapeople.svg`}
              alt="Dalove Image"
              style={css}
              width={110}
              height={23}
              className="inline-block"
            />
            <span className="inline-block ml-2 -mt-1 text-sm align-bottom text-primary">
              of India
            </span>
          </p>
        </div>
      </>
    </>
  )
}

MyAccount.Layout = LayoutAccount

const PAGE_TYPE = PAGE_TYPES.Page

export async function getServerSideProps(context: any) {
  const defaultIndex =
    config.findIndex((element: any) => element.props === context.query.view) ||
    0
  const props: IPagePropsProvider = getPagePropType({ type: PagePropType.COMMON }) as IPagePropsProvider
  const commonPageProps = await props.getPageProps({ cookies: {} })
  return {
    props: {
      ...commonPageProps,
      defaultView: defaultIndex,
    },
  }
}

export default withDataLayer(MyAccount, PAGE_TYPE, true, LayoutAccount)
